export function getSensorBgColor(alarmPriority) {
  let color;
  switch (alarmPriority) {
    case 0:
      //green
      color = '#28a745';
      break;
    case 1:
      //yellow
      color = '#FFFF80';
      break;
    case 2:
      //red
      color = '#FF8080';
      break;
    default:
      //blue
      color = '#80FFFF';
      break;
  }
  return color;
}

export function getSquareBgColor(alarm) {
  let color;
  function checkingExisting(value) {
    return (
      alarm.map((al) => al.alarmPriority).findIndex((el) => el === value) !== -1
    );
  }
  if (checkingExisting(3)) {
    color = '#80FFFF';
    return color;
  } else if (checkingExisting(2)) {
    color = '#FF8080';
    return color;
  } else if (checkingExisting(1)) {
    color = '#FFFF80';
    return color;
  } else {
    color = '#28A745';
    return color;
  }
}
